import { Box, Button, Menu, SpeedDialAction, Tooltip, tooltipClasses } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { CenterStyle } from "styles/GlobalCss";
import { dark } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { thirdly2 } from "styles/theme";
import { gTheme } from "styles/theme";
import { black } from "styles/theme";
import styled from "styled-components";

const WrapLevels = styled.div`
display: flex;
row-gap: 8px;
flex-direction: column;
color: white;
width:100%
`

const Title = styled.div`
color:black;
font-size:18px;
`

const Level = styled.div`
width:100%;
box-sizing:border-box;
background:${props => props.color};
border-radius: 2px;
padding:5px;
font-weight:400;
font-size:15px;
`

const DialAction = muiStyled(SpeedDialAction)(({ theme, color, borderStyle = "solid", borderColor }) => ({
    width: '170px',
    height: '30px',
    borderRadius: 8,
    color: black,
    boxShadow: "none",
    borderWidth: 2,
    borderColor: color,
    borderStyle: "solid",
    fontWeight: 400,
    background: "transparent"
}));

const RatingTableStyles = muiStyled(Box)(({ theme, color, borderStyle = "solid", borderColor }) => ({
    '.rating-item': {

    },
}));

const RatingMenuStyles = muiStyled(Menu)(({ }) => ({
    '.MuiPaper-root.MuiPopover-paper.MuiMenu-paper': {
        borderRadius: 15,
        border: `1px solid ${thirdly2}`
    }
}));

const RatingChipsStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: 7
}));

const RatingItem = muiStyled(Box)(({ color }) => ({
    color: color,
    padding: "12px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: 20
}));

const RatingButtonStyles = muiStyled(Button)(({ theme, color, borderStyle = "solid", borderColor }) => ({
    color: dark,
    background: thirdly4,
    border: `1px solid ${thirdly2}`,
    borderRadius: 20,
    padding: "5px 10px",
    display: "flex",
    columnGap: 10,
    '.circle-question': {
        background: thirdly2,
        borderRadius: 30,
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));

const LevelListSquareStyles = muiStyled(Box)(({ theme, color }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 10,
    [theme.breakpoints.up('xxxxl')]: {
        rowGap: 20
    },
}));

const RatingTooltipStyles = muiStyled(Box)(({ color }) => ({
    '.rating-toolip-items': {
        display: "flex",
        columnGap: 10,
        textWrap: "wrap"
    }
}));

const TooltipRatingLabelStyles = muiStyled(Box)(({ color, selected }) => ({
    color: color,
    fontWeight: selected && "bold",
    whiteSpace: 'nowrap',
    // width: 300
}));

const TooltipStyles = muiStyled(Tooltip)(({ color }) => ({
    display: "flex !important",
    columnGap: "10px !important",
}));

const LevelItemSquareStyles = muiStyled(Box)(({ color }) => ({
    display: "flex",
    columnGap: 10,
    rowGap: 20,
    alignItems: "center",
    '.square': {
        background: color,
        width: 12,
        height: 12
    },
    '.label': {
        color: "black",
        width: 100,
        textAlign: "end"
    }
}));

const LevelListStyles = muiStyled(Box)(({ theme, color }) => ({
    borderRadius: 5,
    border: "1px solid white",
    padding: 30,
    display: "flex",
    rowGap: 10,
    flexDirection: 'column',
    '.list-title': {
        color: theme.dark,
        display: "flex",
        alignItems: "center",
        columnGap: 15
    },
    '.rating-item': {
        display: "flex",
        alignItems: "center",
        columnGap: 15
    }
}));

const RatingDot = muiStyled(Box)(({ theme, color }) => ({
    width: 10,
    height: 10,
    borderRadius: 30,
    background: color
}));

const RatingLabel = muiStyled(Box)(({ theme, color }) => ({
    color: color
}));


const RatingStyles = muiStyled(Box)(({ color, theme }) => ({
    width: 150,
    height: 30,
    color: gTheme[color].main,
    border: `2px solid ${gTheme[color].main}`,
    borderRadius: 6,
    ...CenterStyle
}));


export { RatingChipsStyles, RatingMenuStyles, RatingItem, RatingTableStyles, RatingButtonStyles, TooltipRatingLabelStyles, TooltipStyles, RatingTooltipStyles, LevelItemSquareStyles, LevelListSquareStyles, RatingLabel, RatingDot, LevelListStyles, RatingStyles, DialAction, Title, WrapLevels, Level }